import { useQuery } from '@tanstack/react-query';
import { getAllTenantsRequest } from 'api'; // Змініть на новий endpoint
import { useAuth } from 'context/AuthContext';

function useTenants() {
  const { isAuthenticated } = useAuth();

  const query = useQuery({
    queryKey: ['tenants-all'],
    queryFn: async () => {
      console.log('=== useTenants queryFn executing ===');
      const response = await getAllTenantsRequest('all'); // Новий endpoint
      console.log('Tenants API response:', response);
      console.log('Response data:', response.data);
      return response.data; // Повертаємо response.data напряму
    },
    enabled: !!isAuthenticated,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  console.log('=== useTenants Debug ===');
  console.log('isAuthenticated:', isAuthenticated);
  console.log('query.data:', query.data);
  console.log('query.error:', query.error);
  console.log('query.isLoading:', query.isLoading);
  console.log('============================');

  return query;
}

export default useTenants;
